<template>
  <div class="recordDetail">
    <Navbar :appTitle="title" @eventGetHeight="initHeightFirst" />
    <!--头部-->
    <div class="d-head" id="headdd">
      <div class="content">
        <div class="left">
          <div class="title">
            {{ detailInfo.applicantIdText }}提交的合格品入库申请
          </div>
          <div class="row">{{ detailInfo.applyNo || "--" }}</div>
          <div class="row">
            {{ detailInfo.applicantIdText }},{{ detailInfo.applyTime || "--" }}
            发起申请
          </div>
        </div>
        <!-- ids="MESS_QUALIFIED_INBOUND_APPLY" -->
        <imgStatus
          :flowStatus="detailInfo.flowStatus"
        ></imgStatus>
      </div>
    </div>
    <van-tabs v-model="active" scrollspy sticky :offset-top="runingHeight">
      <!--基本信息 -->
      <van-tab title="入库物料" :style="calssDD">
        <div class="otherTaps">
          <div class="title">
            <span class="icon"></span>
            <span class="content">入库物料</span>
          </div>
          <div
            class="content"
            v-for="(item, index) in detailInfo.messQualifiedListVoList"
            :key="index"
          >
            <div class="row">
              <span class="r-column"
                >{{ item.goodsCode || "--" }}-{{ item.goodsName || "--" }}</span
              >
            </div>
            <div class="row">
              <span class="r-label">物料规格：</span>
              <span class="r-column">{{ item.spec || "--" }}</span>
            </div>
            <div class="row">
              <span class="r-label">工单编号：</span>
              <span class="r-column">{{ item.orderCode || "--" }}</span>
            </div>
            <div class="row">
              <span class="r-label">批次编号：</span>
              <span class="r-column" style="color: #1890ff;">{{ item.batchCode || "--" }}</span>
            </div>
            <div class="row">
              <span class="r-label">本次申请量：</span>
              <span class="r-column"
                >{{ item.num !== "" || item.num !== null ? item.num : "--" }}
                {{ item.spec }}</span
              >
            </div>
            <div class="row">
              <span class="r-label">入库数量：</span>
              <span class="r-column"
                >{{
                  item.inOutBoundNum !== "" || item.inOutBoundNum !== null
                    ? item.inOutBoundNum
                    : "--"
                }}
                {{ item.spec }}</span
              >
            </div>
            <div
              v-if="
                detailInfo.messQualifiedListVoList.indexOf(item) + 1 !==
                detailInfo.messQualifiedListVoList.length
              "
              class="bottomLine"
            ></div>
          </div>
        </div>
      </van-tab>
      <van-tab title="其它">
        <div class="otherTaps" style="margin-top: 0.1rem">
          <div class="title">
            <span class="icon"></span>
            <span class="content">其它</span>
          </div>
          <div class="content">
            <div class="row">
              <span class="r-label">备注：</span>
              <span class="r-column">{{ detailInfo.remark || "--" }}</span>
            </div>
            <div class="row">
              <span class="r-label">附件：</span>
              <span class="r-column">
                <upload
                  class="fileclass"
                  iconType="fj"
                  :fileIds="detailInfo.attachment"
                  :showUpload="false"
                ></upload>
              </span>
            </div>
          </div>
        </div>
      </van-tab>
      <div v-if="detailInfo.flowInstId" class="otherMargin"></div>
      <van-tab v-if="detailInfo.flowInstId" title="审批流程" :style="bottomHeight">
        <div v-if="detailInfo.flowInstId">
          <!-- ids="MESS_QUALIFIED_INBOUND_APPLY" -->
          <Examine
            type="2"
            :id="detailInfo.flowInstId"
            ref="examine"
          />
        </div>
      </van-tab>
    </van-tabs>

    <div class="ExamineBottom"></div>
    <!--提交按钮 -->
    <div v-if="$route.query.applyType == 'waiterDeal'" class="search-bottom">
      <span class="btncancel" @click="cancel">拒绝</span>
      <span class="btnconfirm" @click="confirm">同意</span>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navBar/navBar_right";
import { APILX } from "@/api/requestLx";
import imgStatus from "@/components/imgStatus/imgStatus";
import Examine from "@/components/examine";
import { getEnableOne } from "@/api/api";
import upload from "@/components/upload/upload";
export default {
  name: "qualifiedInputDetail", //合格品入库申请详情
  components: { Navbar, upload, Examine, imgStatus },
  data() {
    return {
      headheight:"",
      topHeight:"",//导航头的高度
      bodyHeight:"",//获取分辨率 
      runingHeight:"", //锚点选项卡距顶部的高度
      bottomHeight:"padding-bottom:1.5rem",//为了撑开底部 锚点准确
      calssDD: "",//锚点的第一个元素位置
      active: 0,
      shows: false, //是否开启了审批
      detailInfo: {},
      title: "合格品入库申请",
      fileIds: "",
    };
  },
  computed: {},
  watch: {
    detailInfo(newVal) {
      this.$nextTick(() => {
        //  alert("2")
        this.getHeight()
      
      })
    },
  },
  mounted() {},
  created() {
    this.getDetail();
    // 判断是否从审批过来
    this.isApproval();
    this.getEnableOne();
  },
  methods: {
    initHeight(t){
      this.bodyHeight=document.body.clientHeight;//屏幕高度
       if(this.bodyHeight>=667){
        if(this.shows){
           this.bottomHeight="padding-bottom:2rem";
        }else{
           this.bottomHeight="padding-bottom:4rem";
        }
      }
      if(this.bodyHeight>=736){
        if(this.shows){
           this.bottomHeight="padding-bottom:2.5rem";
        }else{
           this.bottomHeight="padding-bottom:4rem";
        }
      }
      if(this.bodyHeight>=812){
        if(this.shows){
           this.bottomHeight="padding-bottom:3rem";
        }else{
          this.bottomHeight="padding-bottom:5.2rem";
        }
      }
      if(this.bodyHeight>=844){
        if(this.shows){
           this.bottomHeight="padding-bottom:3.3rem";
        }else{
          this.bottomHeight="padding-bottom:6rem";
        }
      }
      if(this.bodyHeight>=896){
        if(this.shows){
           this.bottomHeight="padding-bottom:3.5rem";
        }else{
           this.bottomHeight="padding-bottom:6rem";
        }
      }
    },
    initHeightFirst(data){
      this.topHeight=data
      // alert(data)
      // alert(data)
        this.getHeight()
       
   },
    getHeight(data) {
      this.bodyHeight=document.body.clientHeight;//屏幕高度
      this.runingHeight =this.topHeight+document.getElementById("headdd").offsetHeight-5;
      // this.runingHeight =this.headheight-5;
      this.calssDD = "margin-top:" + (this.runingHeight - this.topHeight) + "px";
    },
    //   判断是否开启审批
    getEnableOne() {
      getEnableOne({ id: "MESS_QUALIFIED_INBOUND_APPLY", type: "add" }).then((res) => {
        if (res.result && res.result == "false") {
          this.shows = false;
          this.tabsNum -= 1;
        } else {
          this.shows = true;
        }
      });
         this.initHeight(0)
    },
    isApproval() {
      if (localStorage.getItem("approval") === "success") {
        let paramsObj = {
          applyType: "waiterDeal",
        };
        let pathUrl = "/waiterApply";
        this.$router.push({
          path: pathUrl,
          query: paramsObj,
        });
      }
      localStorage.removeItem("approval");
    },
    getDetail() {
      let id = this.$route.query.id;
      APILX.qualifiedInApplyQueryById(id).then((res) => {
        if (res.code == 200) {
          this.detailInfo = res.result;
          console.log(this.detailInfo, "this.detailInfo");
        } else {
          this.$antdMessage.error(res.result);
        }
      });
    },
    cancel() {
      // approveType 1:同意 0:拒绝
      this.$router.push({
        path: "/approval",
        query: { approveType: 0, taskId: this.$route.query.taskId },
      });
    },
    confirm() {
      // approveType 1:同意 0:拒绝
      this.$router.push({
        path: "/approval",
        query: { approveType: 1, taskId: this.$route.query.taskId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/views/workManagement/materialRequisition/materialDetail.scss";
</style>
